<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import OmniSwitch from "@/components/omni/OmniSwitch.vue";
import OmniTextField from "@/components/omni/OmniTextField.vue";
import { useValidation } from "@/composables/useValidation";
import type { StopInfoSeal } from "@/types/trip";

const { t } = useI18n();
const { requiredValidator } = useValidation();

const model = defineModel<StopInfoSeal>({ required: true });

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    errorMessage?: string | null;
  }>(),
  {
    disabled: false,
    errorMessage: null,
  },
);

const emit = defineEmits<{
  (e: "delete"): void;
}>();

const sealNumber = computed<string>({
  get() {
    return model.value.number;
  },
  set(number) {
    model.value = { ...model.value, number };
  },
});

const isIntact = computed<boolean>({
  get() {
    return model.value.intact;
  },
  set(intact) {
    model.value = { ...model.value, intact };
  },
});
</script>

<template>
  <div class="d-flex align-center col-gap-2 mb-4">
    <omni-text-field
      v-model="sealNumber"
      :disabled="props.disabled || !isIntact"
      :error-messages="props.errorMessage ? [props.errorMessage] : []"
      :label="t('trip.seal-number')"
      :required="!props.disabled"
      :rules="props.disabled ? [] : [requiredValidator]"
      class="flex-grow-1"
      data-qa="seal-number-field"
    />

    <v-btn
      :disabled="props.disabled"
      color="error"
      data-qa="delete-seal-button"
      icon="mdi-delete-outline"
      variant="text"
      @click="emit('delete')"
    />

    <omni-switch
      v-model="isIntact"
      :disabled="props.disabled"
      :label="isIntact ? t('trip.seal-intact') : t('general.broken')"
      data-qa="seal-intact-switch"
    />
  </div>
</template>

<style lang="scss" scoped></style>
